/// <amd-module name="VSSUI/Components/Tree/TreeItemProvider" />
import { ITreeItem, ITreeListItem, ITreeItemProvider } from "../../Components/Tree/Tree.Props";

/** @deprecated */
export abstract class TreeItemProvider<T> implements ITreeItemProvider<T> {
    private treeListItemMap: Map<T, ITreeListItem<T>>; // we can use this in IE11 as long as we stick to simple functions like get/set

    constructor() {
        this.treeListItemMap = new Map();
    }

    public abstract getChildren(item: T | undefined): T[] | Promise<T[]>;

    public abstract getTreeItem(item: T): ITreeItem<T>;

    public setTreeListItem(item: T, treeListItem: ITreeListItem<T>): void {
        this.treeListItemMap.set(item, treeListItem);
    }

    public getTreeListItem(item: T): ITreeListItem<T> {
        return this.treeListItemMap.get(item);
    }
}
